import { schema } from 'normalizr'
import {
  actionCrudCreatorsFor,
  createSelectorForEntityKey,
} from '@infotech/lib-api-middleware'
import { LOGGER_SERVICE } from './constants'

export const SERVICES_SCHEMA_NAME = `services`
export const URL = `${LOGGER_SERVICE}/services`

const entitySchema = new schema.Entity(SERVICES_SCHEMA_NAME)

export const apiActions = actionCrudCreatorsFor(SERVICES_SCHEMA_NAME, URL, entitySchema)

export const entitySelector = createSelectorForEntityKey(SERVICES_SCHEMA_NAME)
